import { BaseModel } from './BaseModel';
import { POST_TYPE_NAME } from '../constants';
export class PostType extends BaseModel {
  static LEARNING_ID = 1;
  static ASSESSMENT_ID = 2;

  static get entity() {
    return 'post-types';
  }

  static get fk() {
    return 'post_type_id';
  }

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(null),
      description: this.attr(null)
    };
  }

  get isAssessment() {
    return this.name === POST_TYPE_NAME.ASSESSMENT;
  }

  get isLearning() {
    return this.name === POST_TYPE_NAME.LEARNING;
  }

  get isVideoConference() {
    return this.name === POST_TYPE_NAME.VIDEO_CONFERENCE;
  }

  static apiConfig = {
    actions: {
      fetchAll() {
        return this.get(`/post-types`);
      }
    }
  };
}

export default PostType;
